// Module
var code = "<template>\n    <ux-dialog>\n      <ux-dialog-body>\n        <h3>${title}</h3>\n        <crisp-input-radio yes-no-items.bind=\"true\" class=\"form-bool\" value.bind=\"sharedComputer\"></crisp-input-radio>\n      </ux-dialog-body>\n    </ux-dialog>\n  </template>";
// Exports
export default code;